import {
  Operator,
  OperatorOutputMode,
  Registry,
  XfoOperatorInput,
  XfoOperatorOutput,
  NumberOperatorInput,
  XfoParameter,
} from '@zeainc/zea-engine'

/** An operator for aiming items at targets.
 * @extends Operator
 */
class AttachmentConstraint extends Operator {
  timeInput = new NumberOperatorInput('Time')
  attachedXfoOutput = new XfoOperatorOutput('Attached', OperatorOutputMode.OP_READ_WRITE)
  private attachTargets: any[]
  private attachId: number
  /**
   * Create a gears operator.
   * @param {string} name - The name value.
   */
  constructor(name?: string) {
    super(name)

    this.addInput(this.timeInput)
    this.addOutput(this.attachedXfoOutput)

    this.attachTargets = []
    this.attachId = -1
  }

  addAttachTarget(target: XfoParameter, time: number) {
    const input = this.addInput(new XfoOperatorInput('Target' + this.getNumInputs()))
    input.setParam(target)

    this.attachTargets.push({
      input,
      time,
      offsetXfo: undefined,
    })
  }

  getAttachTarget(attachId: number) {
    return this.getInputByIndex(attachId + 1)
  }

  findTarget(time: number) {
    if (this.attachTargets.length == 0 || time <= this.attachTargets[0].time) {
      return -1
    }
    const numKeys = this.attachTargets.length
    if (time >= this.attachTargets[numKeys - 1].time) {
      return numKeys - 1
    }
    // Find the first key after the specified time value
    for (let i = 1; i < numKeys; i++) {
      const key = this.attachTargets[i]
      if (key.time > time) {
        return i - 1
      }
    }
  }

  /**
   * The evaluate method.
   */
  evaluate() {
    const time = this.getInput('Time').getValue()
    const output = this.getOutputByIndex(0)
    let xfo = output.getValue()

    const attachId = this.findTarget(time)
    if (attachId != -1) {
      const currXfo = this.getAttachTarget(attachId).getValue()
      const attachment = this.attachTargets[attachId]

      if (attachId != this.attachId) {
        if (!attachment.offsetXfo) {
          if (this.attachId == -1) {
            attachment.offsetXfo = currXfo.inverse().multiply(xfo)
          } else {
            const prevXfo = this.getAttachTarget(this.attachId).getValue()
            const prevOffset = this.attachTargets[this.attachId].offsetXfo
            const offsetXfo = currXfo.inverse().multiply(prevXfo.multiply(prevOffset))
            attachment.offsetXfo = offsetXfo
          }
        }
        this.attachId = attachId
      }

      xfo = currXfo.multiply(attachment.offsetXfo)
    }

    output.setClean(xfo)
  }
}

Registry.register('AttachmentConstraint', AttachmentConstraint)

export { AttachmentConstraint }
